export const queryKeys = {
  REGION_PROBLEM_CLASSES: "region-problem-classes",
  REGION_ORGANIZATION_SELECT_ALL: "region-organization-select-all",
  REGION_MAIN_ORGANIZATION_SELECT_ALL: "region-main-organization-select-all",
  REGION_CITY_SELECT_ALL: "region-city-select-all"
}
